// components/SEO.js
import React from 'react';

const SEO = ({ 
  title = "Providence Federal Group | SDVOSB Government Services",
  description = "Service-Disabled Veteran-Owned Small Business providing professional services to federal and state government agencies.",
  keywords = "SDVOSB, government contracting, federal contracts, veteran owned business, Rhode Island",
  image = "/images/og-image.jpg",
  url = "https://providencefederalgroup.com"
}) => {
  return (
    <>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Geo Tags for Local SEO */}
      <meta name="geo.region" content="US-RI" />
      <meta name="geo.placename" content="Providence" />
    </>
  );
};

export default SEO;